// Large applied-Lightning multiplier flash between dice landing and result line.
import { formatLightningMultiplierTenths } from '../game/lightning-types.js';

export interface LightningImpactBounds {
  left: number;
  top: number;
  width: number;
  height: number;
}

function sleep(ms: number): Promise<void> {
  return new Promise((r) => window.setTimeout(r, ms));
}

export class LightningImpact {
  private readonly root: HTMLElement;
  private readonly labelEl: HTMLElement;
  private readonly multEl: HTMLElement;
  private generation = 0;
  private visible = false;

  constructor(host: HTMLElement) {
    this.root = host;
    host.classList.add('lightning-impact-host');
    host.setAttribute('aria-hidden', 'true');
    host.innerHTML = `<div class="lightning-impact" hidden>
      <span class="lightning-impact__label">LIGHTNING</span>
      <span class="lightning-impact__mult"></span>
    </div>`;
    const inner = host.querySelector('.lightning-impact') as HTMLElement;
    this.labelEl = inner.querySelector('.lightning-impact__label')!;
    this.multEl = inner.querySelector('.lightning-impact__mult')!;
  }

  setBounds(bounds: LightningImpactBounds): void {
    this.root.style.left = `${bounds.left}px`;
    this.root.style.top = `${bounds.top}px`;
    this.root.style.width = `${bounds.width}px`;
    this.root.style.height = `${bounds.height}px`;
  }

  /** Shows appliedLightningMultiplier only (not profit or total payout). */
  async show(multiplierTenths: number, reducedMotion: boolean): Promise<void> {
    const gen = ++this.generation;
    const inner = this.root.querySelector('.lightning-impact') as HTMLElement;
    this.multEl.textContent = formatLightningMultiplierTenths(multiplierTenths);
    inner.removeAttribute('hidden');
    inner.classList.remove('lightning-impact--exit');
    inner.classList.add(reducedMotion ? 'lightning-impact--static' : 'lightning-impact--enter');
    this.visible = true;
    this.root.removeAttribute('aria-hidden');

    const holdMs = reducedMotion ? 700 : 900;
    await sleep(holdMs);
    if (gen !== this.generation) return;

    inner.classList.remove('lightning-impact--enter', 'lightning-impact--static');
    inner.classList.add('lightning-impact--exit');
    await sleep(reducedMotion ? 120 : 220);
    if (gen === this.generation) this.hide();
  }

  hide(): void {
    this.generation += 1;
    this.visible = false;
    const inner = this.root.querySelector('.lightning-impact') as HTMLElement;
    inner.setAttribute('hidden', '');
    inner.classList.remove('lightning-impact--enter', 'lightning-impact--exit', 'lightning-impact--static');
    this.root.setAttribute('aria-hidden', 'true');
  }

  cancel(): void {
    if (this.visible) this.hide();
    else this.generation += 1;
  }

  isVisible(): boolean {
    return this.visible;
  }
}
